import * as style from './style.module.css';

const Panel = ({ children, className = '' }) => <div className={`${style.panel} ${className}`}>{children}</div>;

export default Panel;
